/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from 'react-query';
import { API } from 'api';

export interface IEmployeeInfoUpdateListData {
  payload: {
    page?: number;
    from?: number;
    to?: number;
    type?: string;
    eid?: string;
  };
  data: {
    data: any;
    count: number;
  };
}

export const initEmployeeInfoUpdateListPayload: IEmployeeInfoUpdateListData['payload'] = {
  page: 1,
};

const getEmployeeInfoUpdateListData = (data: IEmployeeInfoUpdateListData['payload']) => {
  return API.get()('/api/admin/employeeInfoUpdate/retrieve', data);
};

export const useEmployeeInfoUpdateListData = (data: IEmployeeInfoUpdateListData['payload']) => {
  return useQuery(['employeeInfoUpdates', data], (): any => getEmployeeInfoUpdateListData(data), {
    select: (response: IEmployeeInfoUpdateListData['data']) => {
      return response.data;
    },
  });
};
